import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import Chip from "@material-ui/core/Chip";
import WarningIcon from "@material-ui/icons/Warning";

const styles = theme => ({

  root: {
    width: "100%",
    maxWidth: 850,
    height: 90,
    margin: "14px auto",
    borderRadius: 24,
    overflow: "hidden",
    display: "flex",
    alignItems: "center",
    boxShadow: "0px 8px 20px rgba(0, 0, 0, 0.15)",
    cursor: "pointer",
    transition: "all 0.2s ease",

    "&:hover": {
      transform: "scale(1.01)",
      boxShadow: "0px 12px 28px rgba(0, 0, 0, 0.2)"
    },

    [theme.breakpoints.up("lg")]: {
      height: 110,
      maxWidth: 1000,
    }
  },

  left: {
    width: 140,
    height: "100%",
    backgroundColor: "#0F6B5B",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },

  turmaText: {
    color: "#FFFFFF",
    fontWeight: 700,
    fontSize: 24,

    [theme.breakpoints.up("lg")]: {
      fontSize: 30,
    }
  },

  right: {
    flex: 1,
    backgroundColor: "#E5E5E5",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },

  chipRestricao: {
    border: "1px solid #C68A00",
    color: "#C68A00",
    backgroundColor: "transparent",
    fontWeight: 600,
    fontSize: 14,
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
  }

});

class TurmaRestricaoCard extends React.Component {

  render() {

    const {
      classes,
      turma,
      totalRestricoes,
      onClick
    } = this.props;

    return (
      <Paper elevation={0} className={classes.root} onClick={onClick}>

        {/* ESQUERDA */}
        <div className={classes.left}>
          <Typography className={classes.turmaText}>
            {turma}
          </Typography>
        </div>

        {/* DIREITA */}
        <div className={classes.right}>
          <Chip
            icon={<WarningIcon style={{ fontSize: 18 }} />}
            label={`${totalRestricoes} restrições`}
            className={classes.chipRestricao}
          />
        </div>

      </Paper>
    );
  }
}

TurmaRestricaoCard.propTypes = {
  turma: PropTypes.string.isRequired,
  totalRestricoes: PropTypes.number.isRequired,
  onClick: PropTypes.func
};

export default withStyles(styles)(TurmaRestricaoCard);